export enum WebPhoneAnalyticsEvents {
  StartCallFromModal = 'new_from_modal',
  StartCallFromPage = 'new_from_page',
  ClickToCallWebPhone = 'c2c_web',
  ClickToCallDeskPhone = 'c2c_desk',
  OutboundNumberSearch = 'srch_outbound_num',
  OutboundNumberSelection = 'outbound_num_selected',
  OutboundSearchInputSearched = 'outbnd_srch_inpt_srchd',
  OutboundSearchInputExtensionClicked = 'outbnd_srch_inpt_clkd',
  InviteAnswered = 'inv_answered',
  InviteRejectedClick = 'inv_rej_click',
  InviteRejectedDND = 'inv_rej_dnd',
  InviteRejectedCallLimit = 'inv_rej_call_limit',
  InviteRejectedSecondInvite = 'inv_rej_2nd_inv',
  InviteRejectedBusy = 'inv_rej_busy',
  RestartSipClientErrorClick = 'restart_sipc_err_click',
  RestartSipClientInitClick = 'restart_sipc_init_click',
  RecentlyDialedStartCallClicked = 'rcnt_dialed_start_call_clkd',
  SearchStartCallClicked = 'srch_start_call_clkd',
  SearchStartCallWithOptionsClicked = 'srch_call_primary_clkd',
  SearchDropdownItemClicked = 'srch_call_dropdwn_clkd',
  SendDtmf = 'send_dtmf',
  ShowDialpadClicked = 'show_dialpad_clkd',
  DndOff = 'dnd_off',
  DndOn = 'dnd_on',
  WarmTransfer = 'warm_xfer',
  ColdTransfer = 'cold_xfer',
  ExtSwitched = 'ext_switched',
  ExtSelected = 'ext_selected',
  Deactivated = 'deactivated',
  NetworkConnected = 'network_connected',
  NetworkDisconnected = 'network_disconnected',
}
